import * as moment from 'moment';
import { logSystem } from 'logger';
import { db } from '../database';
import { encrypt_item, decrypt_item } from '../support/crypt';
export const RPCCacheRecordSchema = '++, [userid+path+params], changed';
export class RPCCacheRecord {
    userid;
    path;
    params;
    response;
    changed;
    constructor(userid, path, params, response, changed) {
        this.userid = userid;
        this.path = path;
        this.params = params;
        this.response = response;
        this.changed = changed;
    }
    async save() {
        this.changed = moment().toISOString();
        await db.rpccache.put(this);
    }
    age() {
        const { changed } = this;
        if (changed) {
            const now = moment();
            const old = moment(changed);
            return now.diff(old, 'hours');
        }
        return 0;
    }
}
const rpc_base_len = `${window.hcstatic.portal_url.split('/').slice(0, -1).join('/')}`.length;
const relative_path = (def) => {
    const { target = '' } = def;
    const target_path = target.startsWith('http') ? target.slice(rpc_base_len) : target;
    return target_path;
};
const msg_from_params = (def) => {
    const { data } = def;
    const { method, params } = JSON.parse(data);
    return JSON.stringify({ method, params });
};
const fixup_response = async (response, def) => {
    const { id } = JSON.parse(def.data);
    const robj = await decrypt_item(response);
    robj.id = id;
    return JSON.stringify(robj);
};
const ensure_userid = (userid) => {
    if (userid === '') {
        const authtkt = window.hcstatic.portal_auth_ticket.replace(/"/g, '');
        if (authtkt) {
            userid = window.atob(authtkt).slice(40).split('!')[0];
        }
    }
    return userid;
};
export async function has_rpc_cached(def) {
    const { portal_userid: userid = '' } = window.hcstatic;
    const path = relative_path(def);
    const params = msg_from_params(def);
    const rpcitem = await db.rpccache.where({ path, params, userid }).first();
    return rpcitem !== undefined;
}
export async function get_rpc({ request, action }) {
    if (!request.cacheable) {
        return action();
    }
    let { portal_userid: userid = '' } = window.hcstatic;
    userid = ensure_userid(userid);
    const params = msg_from_params(request);
    const path = relative_path(request);
    try {
        let rpcitem = await db.rpccache.where({ path, params, userid }).first();
        if (rpcitem === undefined) {
            return action().then(async (response) => {
                const crypted = await encrypt_item(response);
                if (rpcitem === undefined) {
                    rpcitem = new RPCCacheRecord(userid, path, params, '');
                    rpcitem.response = crypted;
                    rpcitem.save();
                }
                else {
                    db.rpccache.where({ path, params, userid }).modify({
                        changed: moment().toISOString(),
                        response: crypted
                    });
                }
                return response;
            });
        }
        else {
            const { sitews } = window.hcstatic;
            const lifetime = request.cacheLifetime || 2;
            if (sitews.is_open() && rpcitem.age() > lifetime) {
                const refresh = async () => {
                    try {
                        const response = await encrypt_item(await action());
                        db.rpccache.where({ path, params, userid }).modify({
                            changed: moment().toISOString(),
                            response
                        });
                    }
                    catch (e) {
                        logSystem.warn(() => `cache failed to refresh for ${path} <== ${params}: ${e.message}`);
                    }
                };
                refresh();
            }
        }
        return JSON.parse(await fixup_response(rpcitem.response, request));
    }
    catch (e) {
        console.log(`get_rpc error: ${e.message}`);
        return null;
    }
}
